import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormText } from '~/components/FormControl';
import { Row, Col } from 'react-bootstrap';
import Fight from '../Combat/Fight';
import DiceAndPoint from '../Combat/DiceAndPoint';
import Others from '../Combat/Others';
import DiceAndPointCompareCheck from '../Combat/DiceAndPointCompareCheck';
import FightCheck from '../Combat/FightCheck';
import PhaseEffectCheck from '../Combat/PhaseEffectCheck';
import OthersCheck from '../Combat/OthersCheck';
import ConnectStatusDetail from '~/pages/CardSaga/components/form-sections/StatusDetail/ConnectStatusDetail';
import { useSelector, useDispatch } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { fetchCardMetaDataApi } from '~/pages/CardSaga/cardMetaDataSlice';

function Combat({ asyncApiCall }) {
    const dispatch = useDispatch();
    const { cardMetaData } = useSelector((state) => state.cardSaga.cardMetaData);
    const { statuses, biomes } = cardMetaData;

    useEffect(() => {
        if (isEmpty(cardMetaData)) dispatch(fetchCardMetaDataApi());
    }, []);

    return (
        <>
            <Row className={'justify-content-center'}>
                <FormText
                    name="name"
                    asyncApiCall={asyncApiCall}
                    sm={2}
                />
            </Row>

            <Row className={'justify-content-around'}>
                <Col>
                    <Fight />
                </Col>

                <Col>
                    <DiceAndPoint />
                </Col>

                <Col>
                    <Others />
                </Col>
            </Row>

            <Row className="flex-column pl-3">
                <ConnectStatusDetail
                    statuses={statuses}
                    playerStatuses="playerStatuses"
                    opponentStatuses="opponentStatuses"
                />
            </Row>

            <h2 className="text-center">
                <u>Condition Check</u>
            </h2>
            <Row className={'justify-content-around'}>
                <Col>
                    <DiceAndPointCompareCheck />
                </Col>
                <Col>
                    <FightCheck />
                </Col>
                <Col>
                    <PhaseEffectCheck />
                </Col>
                <Col>
                    <OthersCheck biomes={biomes} />
                </Col>
            </Row>
        </>
    );
}

Combat.propTypes = {
    asyncApiCall: PropTypes.func.isRequired,
};
export default Combat;
